import { useFormik } from "formik";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Form,
    Input,
    Label,
    Row,
} from "reactstrap";
import {
    addSalesOrderReturn,
    categoryLabels,
    discountLabels,
    financialYear,
} from "utils/helpers/constant";
import { PlaceHolderFormat } from "utils/helpers/validationRequiredMessages";
import { toast } from "react-toastify";
import { addDiscount, viewDiscount } from "api/discountApi";
import { ResponseStatusEnum } from "utils/helpers/enums";
import Loader from "Components/Common/loader";

interface viewDiscountData {
    id: number;
    discount_charge: string;
    is_discount: boolean;
}

const Discount = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState<boolean>();
    const [discountableAmount, setDiscountableAmount] = useState<viewDiscountData>();

    const fetchViewDiscount = () => {
        setIsLoading(true);
        viewDiscount({}).then((response) => {
            if (response?.statusCode && ResponseStatusEnum.SUCCESS.includes(response?.statusCode)) {
                setDiscountableAmount(response?.data);
            }
        }).catch((err) => {
            return err
        }).finally(() => {
            setIsLoading(false);
        })
    }

    const handleCancel = () => {
        navigate(-1);
    };

    document.title = addSalesOrderReturn?.Discount;

    useEffect(() => {
        fetchViewDiscount();
    }, [])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            discount_charge: discountableAmount?.discount_charge || 0,
            is_discount: discountableAmount?.is_discount || false,
        },
        onSubmit: (values) => {
            setIsLoading(true);
            const payload = {
                discount_charge: +values?.discount_charge,
                is_discount: values?.is_discount
            }
            addDiscount(payload).then((response) => {
                if (response?.statusCode && ResponseStatusEnum.SUCCESS.includes(response?.statusCode)) {
                    toast.success(response?.message);
                    fetchViewDiscount();
                } else {
                    toast.error(response?.message)
                }
            }).catch((err) => {
                return err;
            }).finally(() => {
                setIsLoading(false);
            })
        },
    });

    return (
        <div className="page-content">
            <Container>
                <Form
                    onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                    }}
                >
                    <Row className="mb-3">
                        <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                            <h5 className="fw-semibold mb-0">{addSalesOrderReturn?.Discount}</h5>
                        </div>
                        <div className="col-auto order-2 order-sm-3 ms-auto">
                            <div className="hstack gap-2">
                                <button
                                    className="btn btn-primary createTask"
                                    type="button"
                                    onClick={handleCancel}
                                >
                                    {financialYear?.back}
                                </button>
                            </div>
                        </div>
                    </Row>
                    <Row>
                        <Col lg={5}>
                            <Card>
                                <CardBody>
                                    <Label className="">{addSalesOrderReturn?.Discount}</Label>
                                    <Input
                                        type="text"
                                        name="discount_charge"
                                        className="m-1 mb-3"
                                        title={addSalesOrderReturn.Discount}
                                        placeholder={PlaceHolderFormat(addSalesOrderReturn.Discount)}
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.discount_charge || ""}
                                        invalid={!!(validation.touched.discount_charge && validation.errors.discount_charge)}
                                    />
                                    <div className="text-end d-flex justify-content-between">
                                        <div
                                            className="form-check form-switch form-switch-md mx-1"
                                            dir="ltr"
                                        >
                                            <Input
                                                type="checkbox"
                                                name="is_discount"
                                                className="form-check-input"
                                                id="is_discount"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                checked={validation.values.is_discount || false}
                                                invalid={!!(validation.touched.is_discount && validation.errors.is_discount)}
                                            />
                                            <Label
                                                className="form-check-label"
                                                for="is_discount"
                                            >
                                                {discountLabels.discountEnabled}
                                            </Label>
                                        </div>

                                        <Button
                                            color="primary"
                                            className="w-sm me-2"
                                            disabled={!validation.dirty}
                                        >
                                            {categoryLabels?.submit}
                                        </Button>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Form>
            </Container>
            {isLoading && <Loader />}
        </div>
    );
};

export default Discount;
